var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.long
    ? _c(
        "t-button",
        {
          class:
            _vm.accessControl == "disabled"
              ? "t-share__btn-disabled"
              : "t-share__btn-primary",
          attrs: {
            variant: "primary",
            disabled: _vm.accessControl == "disabled",
          },
          on: {
            click: function ($event) {
              return _vm.copyLinkCode()
            },
          },
        },
        [
          !_vm.linkCopyingInProgress
            ? [
                _vm.accessControl == "disabled"
                  ? _c("i", { staticClass: "mdi mdi-link-off mdi-32px" })
                  : _c("i", { staticClass: "mdi mdi-link mdi-32px" }),
                _vm._v(" "),
                !_vm.$isMobile
                  ? _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.accessControl == "disabled"
                            ? "Link disabled"
                            : _vm.$t("generic.button.copy_link")
                        )
                      ),
                    ])
                  : _vm._e(),
              ]
            : [_vm._v(_vm._s(_vm.$t("generic.link.copied")))],
        ],
        2
      )
    : _c(
        "div",
        [
          _c("t-input", {
            attrs: {
              fluid: "",
              value: _vm.videoShareableLink,
              label: "Shareable Link",
              readonly: true,
            },
          }),
          _vm._v(" "),
          _c(
            "t-button",
            {
              staticClass: "t-mar--t-xs",
              attrs: {
                size: "xsmall",
                disabled: _vm.accessControl == "disabled",
              },
              on: {
                click: function ($event) {
                  return _vm.copyLinkCode()
                },
              },
            },
            [
              !_vm.linkCopyingInProgress
                ? [
                    _c("i", { staticClass: "mdi mdi-content-copy mdi-18px" }),
                    _c("span", [_vm._v(_vm._s(_vm.$t("generic.button.copy")))]),
                  ]
                : [_vm._v(_vm._s(_vm.$t("generic.link.copied")))],
            ],
            2
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }